export default {"src":"/_next/static/media/chatLine.e65dc96a.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};